import { render, staticRenderFns } from "./NewsSection.vue?vue&type=template&id=b1f133a8&"
import script from "./NewsSection.vue?vue&type=script&lang=js&"
export * from "./NewsSection.vue?vue&type=script&lang=js&"
import style0 from "./NewsSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports